import { render } from "./CashierDashboard.vue?vue&type=template&id=472e8418"
import script from "./CashierDashboard.vue?vue&type=script&lang=js"
export * from "./CashierDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__